import React from 'react'
import { CheckboxInput } from '@ztechapps/webui.input'
import { useTaskListContext } from './Context'
import { ShowIf } from '@ztechapps/webui.util'

export const TaskListHeader = () => {
  const { taskListWithSelection, disabled, enableReorder, scrollable } = useTaskListContext()
  const { toggleSelectAll, hasSelectedAll } = taskListWithSelection
  return (
    <thead className={scrollable ? 'position-sticky top-0 bg-body' : ''} style={scrollable ? { zIndex: 2 } : undefined}>
      <tr>
        <th style={{ width: '1px' }} />
        <ShowIf condition={!disabled}>
          <th style={{ width: '1px' }} className="px-0">
            <CheckboxInput onChange={toggleSelectAll} checked={hasSelectedAll} />
          </th>
          <ShowIf condition={!!enableReorder}>
            <th style={{ width: '1px' }} />
          </ShowIf>
        </ShowIf>
        <th>Name</th>
        <th style={{ width: '130px' }}>Status</th>
        <th style={{ width: '15%' }}>Start date</th>
        <th style={{ width: '15%' }}>Due date</th>
        <th style={{ width: '15%' }}>Time spent</th>
        <th style={{ width: '15%' }}>Members</th>
        <th className="text-end " style={{ width: '30px' }}></th>
      </tr>
    </thead>
  )
}
